"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandlingHelper = void 0;
class ErrorHandlingHelper {
    constructor() {
        this._errors = [];
    }
    getErrors() {
        return this._errors;
    }
    getError(name) {
        for (const validationError of this._errors) {
            if (validationError.name === name) {
                return validationError;
            }
        }
        return undefined;
    }
    hasErrors() {
        return this._errors.length > 0;
    }
    hasError(name) {
        return this.getError(name) !== undefined;
    }
    addError(error) {
        if (error.name && this.hasError(error.name)) {
            this.clearError(error.name);
        }
        this._errors.push(error);
    }
    clearErrors() {
        this._errors = [];
    }
    clearError(name) {
        for (let i = 0; i < this._errors.length; i++) {
            if (this._errors[i].name === name) {
                this._errors.splice(i, 1);
            }
        }
    }
}
exports.ErrorHandlingHelper = ErrorHandlingHelper;
//# sourceMappingURL=ErrorHandlingHelper.js.map